import React     from 'react';
import { Route } from 'react-router-dom';

import Wrapper         from '../Containers/Wrapper';
import WrapperConsumer from '../store';

const PublicRoute = (props) => {
  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(routeProps) => {
        return (
          <Wrapper >
            <Component {...routeProps} />
          </Wrapper>
        )
      }}
    />
  );
};

export default WrapperConsumer(PublicRoute);